<template>
  <div class="page flex-col">
    <div class="header flex-row">
      <BackButton
        :customClick="handleBackClick"
        class="back"
      />
      
      <Dropdown
        class="select_item"
        :options="academicOptions"
        placeholder="学年"
        @selection-change="handleYearSelection"
      />

      <Dropdown
        class="select_item"
        :options="classOptions"
        placeholder="班级"
        @selection-change="handleClassSelection"
      />
    </div>

    <div class="menu flex-row">
      <TeacherMenu />
    </div>

    <div class="container flex-row">
      <div class="left_box flex-col">
        <div class="course_name">{{ lessonName }}</div>
        <div class="left_table">
          <DataTable
            :headers="tableHeaders"
            :items="loopData"
            :idx="0"
            show-pagination="true"
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @item-click="handleItemClick"
            @page-change="handlePageChange"
          />
        </div>
      </div>
      <div class="right_box flex-col">
        <TaskTable
          :headers="taskHeaders"
          :items="taskData"
          @item-click="handleItemTaskClick"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"

import Dropdown from "@/components/teacher/Dropdown.vue"
import DataTable from "@/components/teacher/DataTable.vue"
import TaskTable from "@/components/teacher/TaskTable.vue"
import BackButton from "@/components/teacher/BackButton.vue"
import TeacherMenu from "@/components/teacher/TeacherMenu.vue"
import alovaInstance from "@/utils/alova"

const route = useRoute()
const store = useStore()
const router = useRouter()
const lessonName = ref("")
const academicOptions = ref([])
const classOptions = ref([])
const academicYear = ref("")
const classId = ref(-1)
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const tableHeaders = [
  {
    key: "studentId",
    label: "ID",
    style: "width: 1.8vw;",
    cellStyle: "width: 8.8vw;",
  },
  {
    key: "studentNo",
    label: "学号",
    style: "width: 6.8vw;",
    cellStyle: "width: 7.5vw;text-align: left;margin-left: 0.9vw;",
  },
  {
    key: "name",
    label: "姓名",
    style: "width: 7.5vw;",
    cellStyle: "width: 8.8vw;text-align: left;",
  },
]

// const loopData = ref([
//   {
//     id: 1,
//     studentNo: "20240101",
//     studentName: "张三",
//   },
// ])
const loopData = ref([])

const taskHeaders = [
  {
    key: "taskSerialNo",
    label: "任务",
    style: "width: 1.8vw;",
    cellStyle: "width: 8vw;text-align: center;",
  },
  {
    key: "taskName",
    label: "任务名称",
    style: "width: 6.8vw;",
    cellStyle: "width: 7.5vw;text-align: left;margin-left: -0.3vw;",
  },
  {
    key: "attemptCount",
    label: "尝试次数",
    style: "width: 7.5vw;",
    cellStyle: "width: 4vw;text-align: center;",
  },
  {
    key: "score",
    label: "得分",
    style: "width: 7.5vw;",
    cellStyle: "width: 13vw;text-align: center;",
  },
  {
    key: "teacherScore",
    label: "教师评分",
    style: "width: 7.5vw;",
    cellStyle: "width: 5vw;text-align: center;margin-left: -2.5vw;",
  },
  {
    key: "teacherComment",
    label: "教师评语",
    style: "width: 7.5vw;",
    cellStyle: "width: 8.8vw;text-align: left;margin-left: 3vw;",
  },
  {
    key: "statu",
    label: "记录",
    style: "width: 7.5vw;",
    cellStyle: "width: 2.6vw;height: 4.17vw;margin-left: 0.6vw;",
  },
]

// const taskData = ref([
//   {
//     idx: 1,
//     taskName: "数项目",
//     try: 0,
//     score: 10,
//     teacherScore: 10,
//     mark: "不错",
//     task: 2,
//   }
// ])
const taskData = ref([])

onMounted(async () => {
  lessonName.value = store.getters.getLessonName
  try {
    const response = await alovaInstance.Post("/Class/GetAllAcademic")
    if (response.code === 1000) {
      academicOptions.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }

    const allClass = await alovaInstance.Post("/Class/GetAllClass")
    if (allClass.code === 1000) {
      // console.log(allClass.data)
      classOptions.value = []
      for (let i = 0; i < allClass.data.length; i++) {
        classOptions.value.push({
          label: allClass.data[i].class_name,
          value: allClass.data[i].id,
        })
      }
    } else {
      alert("获取数据失败：" + allClass.message)
    }

    handleSelection()
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const handleSelection = async () => {
  try {
    const response = await alovaInstance.Post("/Record/GetStudentTaskStatu", {
      lessonId: route.query.lessonId,
      academicYear: academicYear.value,
      classId: classId.value,
      pageIndex: currentPage.value,
      pageSize: pageSize.value,
    })
    // console.log(response)
    if (response.code === 1000 && response.data != null) {
      loopData.value = response.data.studentRecordDetailInfoList
      total.value = response.data.totalCount
      // loopData.value = loopData.value.concat(loopData.value)
      if (
        response.data.studentRecordDetailInfoList != null &&
        response.data.studentRecordDetailInfoList.length > 0
      )
        taskData.value =
          response.data.studentRecordDetailInfoList[0].taskRecordInfos
      else {
        taskData.value = []
      }
      // loopData.value = loopData.value.concat(loopData.value).concat(loopData.value)
    } else if (response.code === 1000 && response.data == null) {
      loopData.value = []
      taskData.value = []
      total.value = 0
      alert("没有符合条件的学生")
    } else {
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
}

const handlePageChange = (page) => {
  currentPage.value = page
  handleSelection()
}

const handleYearSelection = (year) => {
  // console.log("Selected year:", year)
  academicYear.value = year
  handleSelection()
}

const handleClassSelection = (value) => {
  // console.log("Selected class:", value)
  classId.value = value
  handleSelection()
}

const handleItemClick = async (item) => {
  taskData.value = item.taskRecordInfos
}

const handleItemTaskClick = () => {}

const handleBackClick = () => {
  router.push({
    name: "TeacherCourse",
    query: {
      courseName: store.state.courseName,
      courseId: store.state.courseId,
    },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.header {
  width: 80.6771vw;
  height: 3.4375vw;
  margin: 0.8854vw 0 0 1.5vw;
}

.back {
  margin-right: 1.5vw;
}

.select_item {
  margin: 0.05vw 0 0 1.25vw;
}

.menu {
  width: auto;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.container {
  width: 80.68vw;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.left_box {
  width: auto;
  margin-top: 1.15vw;
}

.course_name {
  width: 20vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 1.05vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left_table {
  position: relative;
  width: 26.6vw;
  height: auto;
  min-height: 32vw;
  margin-top: 1.15vw;
}

.right_box {
  width: 53.2vw;
  margin-left: 1.15vw;
  margin-top: 1.5vw;
}
</style>
